import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PDPGalleryLabels from 'components/consumer/PDP/PDPGalleryLabels';

const PDPGalleryLabelsAndViewingCount = ({ mode = 'pdp' }) => (
  <div
    className={classNames(
      'bg-yellow-light rounded flex h-[25px] pointer-events-none hover:cursor-target [&_>_*]:ml-2 [&_>_*:first-child]:ml-0 max-[1023px]:md:mt-10',
      {
        'PDPGalleryLabelsAndViewingCount--mode-pdp': mode === 'pdp',
        'max-[1023px]:md:mt-0': mode === 'quickview',
      }
    )}
  >
    <PDPGalleryLabels />
  </div>
);

PDPGalleryLabelsAndViewingCount.propTypes = {
  mode: PropTypes.oneOf(['pdp', 'quickview']),
};

export default PDPGalleryLabelsAndViewingCount;
